<template>
    <calculation-demand-contact-select/>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import CalculationDemandContactSelect from './DemandContactSelect';

    export default {
        name: 'CalculationDemandContactSelectContainer',
        components: {
            CalculationDemandContactSelect
        },
        mounted() {
            const {bimId} = this.$route.query;
            this.setBimId(bimId);
            if (null === this.selectedConstructionId && null === this.bimId) {
                this.$router.push({name: 'calculation.projectSelect'});
            }
        },
        computed: {
            ...mapGetters('calculation', ['selectedConstructionId', 'bimId']),
        },
        methods: {
            ...mapActions('calculation', ['setBimId']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandContactSelectContainer.vue